"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var index_1 = __importDefault(require("../../../index"));
var Formik_1 = __importDefault(require("../../../Elements/TextInput/Formik"));
var Formik_2 = __importDefault(require("../../../Elements/Select/Formik"));
var Button_1 = __importDefault(require("../../../Elements/Button"));
var Formik_3 = __importDefault(require("../../../Elements/Radio/Group/Formik"));
var Formik_4 = __importDefault(require("../../../Elements/Date/Picker/Formik"));
var Formik_5 = __importDefault(require("../../../Elements/TextArea/Formik"));
var Formik_6 = __importDefault(require("../../../Elements/Upload/DragAndDrop/Formik"));
var schema_1 = __importDefault(require("./schema"));
var CreateInquiry = function (_a) {
    var mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, weightSetting = _a.weightSetting, volumeSetting = _a.volumeSetting, projectSelect = _a.projectSelect, containerSelect = _a.containerSelect, _b = _a.initialValues, initialValues = _b === void 0 ? {
        reporter: "",
    } : _b, onSuccess = _a.onSuccess;
    var CASE_TYPES = [
        { label: "Miss-sorted Waste", value: "Miss-sorted Waste" },
        { label: "Overflowing", value: "Overflowing" },
        { label: "Damaged", value: "Damaged" },
        { label: "Bulky Waste", value: "Bulky Waste" },
        { label: "Other", value: "Other" },
    ];
    var PRIORITY_LEVEL = [
        { label: "Critical", value: "Critical" },
        { label: "High", value: "High" },
        { label: "Medium", value: "Medium" },
        { label: "Low", value: "Low" },
    ];
    return (react_1.default.createElement(index_1.default, { mutation: mutation, mutationVariablesFormatter: mutationVariablesFormatter, onSuccess: onSuccess, formikProps: {
            initialValues: initialValues,
            validationSchema: schema_1.default,
            onSubmit: function () { return console.log("not-used"); },
        } }, function (_a) {
        var isSubmitting = _a.isSubmitting, submitForm = _a.submitForm;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Formik_1.default, { antd: {
                    label: "Reporter",
                    required: true,
                    tooltip: {
                        title: "The name of the person making the inquiry",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                }, name: "reporter" }),
            projectSelect,
            containerSelect,
            react_1.default.createElement(Formik_2.default, { options: CASE_TYPES, name: "caseType", antd: {
                    label: "Case Type",
                    required: true,
                    tooltip: {
                        title: "Which case type does this incident involve?",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                } }),
            react_1.default.createElement(Formik_3.default, { antd: {
                    label: "Priority",
                    required: true,
                    tooltip: {
                        title: "What is the priority level?",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                }, options: PRIORITY_LEVEL, optionType: "button", name: "priority", buttonStyle: "solid" }),
            react_1.default.createElement(Formik_4.default, { antd: {
                    label: "Deadline",
                    tooltip: {
                        required: true,
                        title: "Deadline for pick-up.",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                }, name: "deadline", style: { display: "grid" } }),
            react_1.default.createElement(Formik_5.default, { name: "comment", antd: {
                    label: "Comment",
                    required: true,
                    tooltip: {
                        title: "Enter a comment if needed.",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                }, rows: 3, placeholder: "Enter a comment here..." }),
            react_1.default.createElement(Formik_6.default, { name: "upload", antd: {
                    label: "Upload",
                    tooltip: {
                        title: "Drag and drop relevant files/pictures.",
                        icon: react_1.default.createElement(icons_1.InfoCircleOutlined, null),
                    },
                    labelCol: { span: 24, offset: 0 },
                } }),
            react_1.default.createElement(Formik_1.default, { name: "wasteVolumeEstimate", placeholder: "Estimate of the waste volume.", suffix: volumeSetting, antd: {
                    label: "Waste Volume Estimate",
                    labelCol: { span: 24, offset: 0 },
                } }),
            react_1.default.createElement(Formik_1.default, { name: "wasteWeightEstimate", placeholder: "Estimate of the waste weight.", suffix: weightSetting, antd: {
                    label: "Waste Weight Estimate",
                    labelCol: { span: 24, offset: 0 },
                } }),
            react_1.default.createElement(Button_1.default, { type: "primary", disabled: isSubmitting, title: "Submit", onClick: submitForm })));
    }));
};
exports.default = CreateInquiry;
